/* --------------------------------------------------
  novice-section-contact-form.js
  v1.0.2
  最終更新: 2024-09-12 06:00:00
  多言語対応版
-------------------------------------------------- */
  
(() => {
// const
const VIDEO_SIZE_LIMIT_MB = 100;
const FILE_SIZE_LIMIT_MB = 5;
const NUMBER_OF_FIELD_LIMIT = 5;
const UPLOAD_ENDPOINT = "https://api2.hi-cs.mu-mo.com/api/cs/contact/file/upload";
const HIDDEN_CLASS = 'hide';
// const DEFAULT_FILE_LABEL_INPUT = '選択されていません';
// const DEFAULT_FILE_LABEL_INPUT = document.getElementById("novice-file-label-value-defalut").innerHTML;
const DEFAULT_FILE_LABEL_INPUT = document.querySelector(".novice-file-label-value").innerHTML;
  
// elements
const seciton = document.getElementById("novice-file-upload-section");
const appendButton = document.getElementById('novice-append-file-field-button');
const fieldWrap = document.getElementById("novice-file-fields");
const fileInputPrototype = fieldWrap.querySelector(".novice-file-input");
const clearButtonPrototype = fieldWrap.querySelector(".novice-clear-file-field-button");
const deleteButtonPrototype = fieldWrap.querySelector(".novice-delete-file-field-button");
const loaderDialog = document.querySelector("dialog.novice-dialog");

// events
appendButton.addEventListener('click', handleOnAppendField);
clearButtonPrototype.addEventListener('click', handleOnClearField);
deleteButtonPrototype.addEventListener('click', handleOnDeleteField);
fileInputPrototype.addEventListener('change', handleOnFileChange);

handleOnAppendField();

// functions
function handleOnAppendField(event) {
  const fields = fieldWrap.querySelectorAll(".novice-file-field");
  
  if (fields.length === (NUMBER_OF_FIELD_LIMIT - 1)) {
    appendButton.classList.add(HIDDEN_CLASS);
  }

  if (fields.length < NUMBER_OF_FIELD_LIMIT) {    
    const cloned = fields[0].cloneNode(true);
    cloned.querySelector(".novice-file-input").value = '';
    cloned.querySelector(".novice-file-concrete-input").value = '';
    cloned.querySelector(".novice-file-check-input").value = '';
    cloned.querySelector(".novice-delete-file-field-button").style = "";
    cloned.querySelector('.novice-file-label-value').innerHTML = DEFAULT_FILE_LABEL_INPUT;
    
    fieldWrap.appendChild(cloned);
    
    const iter = fieldWrap.querySelectorAll(".novice-file-field").entries();
    for (let [index, field] of iter) {
      const seq = index + 1;
      const fileName = `file-${seq}`;
      const concreteFileName = `contact[file-${seq}]`;
      const checkFileName = `contact[file-check-${seq}]`;
      
      const fileInput = field.querySelector(".novice-file-input");
      const concreteFileInput = field.querySelector(".novice-file-concrete-input");
      const checkFileInput = field.querySelector(".novice-file-check-input");
      const deleteButton = field.querySelector(".novice-delete-file-field-button");
      const clearButton = field.querySelector(".novice-clear-file-field-button");

      fileInput.name = fileName;
      concreteFileInput.name = concreteFileName;
      checkFileInput.name = checkFileName;

      fileInput.removeEventListener('change', handleOnFileChange);
      fileInput.addEventListener('change', handleOnFileChange);

      deleteButton.removeEventListener('click', handleOnDeleteField);
      deleteButton.addEventListener('click', handleOnDeleteField);
      
      clearButton.removeEventListener('click', handleOnClearField);
      clearButton.addEventListener('click', handleOnClearField);
    }
  }
}

function handleOnClearField(event) {
  const context = this;
  const target = event.target;
  const field = target.closest('.novice-file-field');

  const fileInput = field.querySelector('.novice-file-input');
  const concreteInput = field.querySelector('.novice-file-concrete-input');
  const checkInput = field.querySelector('.novice-file-check-input');
  const labelFileValue = field.querySelector('.novice-file-label-value');
  
  fileInput.value = '';
  concreteInput.value = '';
  checkInput.value = '';
  labelFileValue.innerHTML = DEFAULT_FILE_LABEL_INPUT;
}

function handleOnDeleteField(event) {
  const context = this;
  const target = event.target;
  const field = target.closest('.novice-file-field');

  const fields = fieldWrap.querySelectorAll(".novice-file-field");

  appendButton.classList.remove(HIDDEN_CLASS);
  
  if (fields.length <= 1) {
    return;
  }
  
  field.remove();
}

async function handleOnFileChange(event) {
  const file = event.target.files[0];
  const field = this.closest('.novice-file-field');
  
  console.log('the field', field);
  
  if (!file) {
    const concreteInput = this.parentNode.nextElementSibling;
    concreteInput.value = null;
    const checkinput = field.querySelector('.novice-file-check-input');
    checkinput.value = null;
    const labelFileValue = field.querySelector('.novice-file-label-value');
    labelFileValue.innerHTML = DEFAULT_FILE_LABEL_INPUT;
    return;
  }
  
  document.documentElement.classList.add('novice-clip');
  document.body.classList.add('novice-clip');
  loaderDialog.showModal();
  try {
    validateFile(file, this);
    const formData = new FormData();
    formData.append('file', file);

    const res = await fetch(UPLOAD_ENDPOINT, {
      method: "POST",
      body: formData
    });
    const data = await res.json();

    console.log(data);

    if (data.code !== 200) {
      // const errorType = data.type;
      const errorType = data.error.message;

      throw new Error(errorType);
    }

    const concreteUrl = data.file_url;
    const checkUrl = data.file_check_url || 'file_check_url未定義';
    const concreteInput = this.parentNode.nextElementSibling;
    const urlinput = field.querySelector('.novice-file-concrete-input');
    console.log('urlinput', urlinput);
    const checkinput = field.querySelector('.novice-file-check-input');
    console.log('checkinput', checkinput);
    const labelFileValue = field.querySelector('.novice-file-label-value');
    
    concreteInput.value = concreteUrl;
    checkinput.value = checkUrl;
    labelFileValue.innerHTML = file.name;
  } catch (error) {
    this.value = '';
    console.error(error);
    alert(error.message);

  } finally {
    document.documentElement.classList.remove('novice-clip');
    document.body.classList.remove('novice-clip');
    loaderDialog.close();
  }
  
}

function validateFile(file) {
  const size = file.size;
  const mime = file.type;
  
  if (!mime) {
    throw new Error(`不正なファイル種類です`); 
  }
  
  const mimeTypeParts = mime.split('/');
  
  if (mimeTypeParts[0] === 'video') {
    const isRange = size <= (VIDEO_SIZE_LIMIT_MB * 1024 * 1024);
    if (!isRange) {
     throw new Error(`動画ファイルは１ファイル${VIDEO_SIZE_LIMIT_MB}Mbまで`); 
    }
    return
  }

  const isRange = size <= (FILE_SIZE_LIMIT_MB * 1024 * 1024);
  if (!isRange) {
    throw new Error(`画像ファイルは１ファイル${FILE_SIZE_LIMIT_MB}Mbまで`); 
  }
}
})();